module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img34.9925082f.jpg";